import React from 'react'
import Bredcrumb from '../Common/Bredcrumb'

const Sitemap = () => {
  return (
    <>
      <Bredcrumb title="Sitemap" />
      <section className='mt-4'>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mb-1-9 mb-lg-0">
                            text here....
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Sitemap
